<template>
  <div>
    <v-container fluid class="px-0 py-2">
      <v-layout row wrap :justify-center="center">
        <v-flex sm12 md8>
          <v-btn
            block
            class="gradiente"
            style="border-radius: 33px;"
            dark
            @click="show"
          >Seleccionar archivo o video</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <input
      ref="doc"
      name="doc"
      type="file"
      id="doc"
      accept=".pdf, .mp4, .docx, .xlsx, .pptx, .zip"
      style="display: none;"
      @change="onChange"
    />
    <alert
      v-model="modals.warning"
      v-if="modals.warning"
      title="Verifica el formato de tu archivo"
      description="El tipo de archivo es incorrecto. Puede subir archivos de tipo PDF, Word, Excel, PowerPoint, ZIP o MP4."
    ></alert>
    <alert
      v-model="modals.size"
      v-if="modals.size"
      title="Verifica el tamaño de tu archivo"
      description="El archivo que intentaste añadir es mayor al límite de 15 MB."
    ></alert>
  </div>
</template>

<script>
import alert from "../Dialogs/Alert";
export default {
  components: {
    alert
  },
  props: ["center"],
  data: () => ({
    modals: {
      warning: false,
      size: false
    }
  }),
  methods: {
    show() {
      this.$refs.doc.click();
    },
    onChange(e) {
      var files = e.target.files;
      var file = files[0];
      if (files && file) {
        if (file.size < 15 * 1024 * 1024) {
          var reader = new FileReader();
          var v = this;
          reader.onload = function(readerEvt) {
            var allowedExtensions = /(.pdf|.mp4|.zip|.docx|.xlsx|.pptx)$/i;
            var ext = allowedExtensions.exec(file.name) ? true : false;
            if (ext) {
              var binaryString = readerEvt.target.result;
              v.$emit("selected-file", {
                name: file.name,
                type: file.type.split("/")[1],
                size: file.size,
                file: btoa(binaryString)
              });
              document.getElementById("doc").value = "";
            } else {
              document.getElementById("doc").value = "";
              v.modals.warning = true;
            }
          };
          reader.readAsBinaryString(file);
        } else {
          e.target.value = "";
          this.modals.size = true;
        }
      }
    }
  }
};
</script>

<style>
</style>